import { ChevronDown } from 'lucide-react'

import { cn } from '@/lib/utils'

/** Chevron for outline / split dropdown triggers — keep markup identical everywhere. */
export function ButtonDropdownChevron({ className }: { className?: string }) {
  return <ChevronDown className={cn('h-4 w-4 shrink-0', className)} aria-hidden />
}
